(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-article-nomadflow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-nba-article-section]');

    sections.forEach(function (section) {
      const content = section.querySelector('[data-nba-article-content]');
      const tocCard = section.querySelector('[data-nba-toc-card]');
      const tocList = section.querySelector('[data-nba-toc-list]');

      if (!content || !tocCard || !tocList) return;

      const headings = content.querySelectorAll('h2');

      if (!headings.length) {
        tocCard.remove();
        return;
      }

      tocList.innerHTML = '';

      headings.forEach(function (heading, index) {
        const headingText = heading.textContent.trim();

        if (!headingText) return;

        if (!heading.id) {
          let slug = headingText
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');

          if (!slug) {
            slug = 'section-' + (index + 1);
          }

          let uniqueSlug = slug;
          let counter = 2;

          while (document.getElementById(uniqueSlug)) {
            uniqueSlug = slug + '-' + counter;
            counter++;
          }

          heading.id = uniqueSlug;
        }

        const item = document.createElement('li');
        const link = document.createElement('a');

        link.href = '#' + heading.id;
        link.textContent = headingText;

        item.appendChild(link);
        tocList.appendChild(item);
      });

      if (tocList.children.length > 0) {
        tocCard.hidden = false;
      } else {
        tocCard.remove();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-legal-pages"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var submittedAtField = document.getElementById('RetractionSubmittedAt');

  if (!submittedAtField) {
    return;
  }

  var now = new Date();

  submittedAtField.value = now.toLocaleString('fr-FR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cpg-swatches')) {
    class CpgSwatches extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.cpg-swatch').forEach(swatch => {
          swatch.addEventListener('click', () => {
            this.querySelectorAll('.cpg-swatch').forEach(s => s.classList.remove('cpg-swatch--active'));
            swatch.classList.add('cpg-swatch--active');
          });
        });
      }
    }
    customElements.define('cpg-swatches', CpgSwatches);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reassurance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trackSelector = '[data-nf-reassurance-track]';
    const mobileLayout = window.matchMedia('(max-width: 749px)');

    const initialiseTrack = (track) => {
      if (!track || track.dataset.nfMouseDragInitialised === 'true') {
        return;
      }

      track.dataset.nfMouseDragInitialised = 'true';

      let isDragging = false;
      let hasMoved = false;
      let startX = 0;
      let startScrollLeft = 0;
      let activePointerId = null;

      const snapToNearestCard = () => {
        const cards = Array.from(
          track.querySelectorAll('.nf-reassurance-item')
        );

        if (cards.length === 0) {
          return;
        }

        const trackCentre = track.scrollLeft + track.clientWidth / 2;
        let nearestCard = cards[0];
        let nearestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card) => {
          const cardCentre = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(trackCentre - cardCentre);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestCard = card;
          }
        });

        const isFirstCard = nearestCard === cards[0];

        const targetLeft = isFirstCard
          ? 0
          : nearestCard.offsetLeft -
            (track.clientWidth - nearestCard.offsetWidth) / 2;

        track.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth'
        });
      };

      const stopDragging = (event) => {
        if (!isDragging) {
          return;
        }

        isDragging = false;
        track.classList.remove('is-dragging');

        if (
          activePointerId !== null &&
          track.hasPointerCapture?.(activePointerId)
        ) {
          track.releasePointerCapture(activePointerId);
        }

        activePointerId = null;

        if (hasMoved && mobileLayout.matches) {
          window.requestAnimationFrame(snapToNearestCard);
        }

        if (event) {
          event.preventDefault();
        }
      };

      track.addEventListener('pointerdown', (event) => {
        if (
          !mobileLayout.matches ||
          event.pointerType !== 'mouse' ||
          event.button !== 0
        ) {
          return;
        }

        isDragging = true;
        hasMoved = false;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        activePointerId = event.pointerId;

        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!isDragging || event.pointerId !== activePointerId) {
          return;
        }

        const distance = event.clientX - startX;

        if (Math.abs(distance) > 4) {
          hasMoved = true;
        }

        track.scrollLeft = startScrollLeft - distance;

        if (hasMoved) {
          event.preventDefault();
        }
      });

      track.addEventListener('pointerup', stopDragging);
      track.addEventListener('pointercancel', stopDragging);
      track.addEventListener('lostpointercapture', stopDragging);

      track.addEventListener(
        'click',
        (event) => {
          if (!hasMoved) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          hasMoved = false;
        },
        true
      );

      track.addEventListener('keydown', (event) => {
        if (!mobileLayout.matches) {
          return;
        }

        const distance = track.clientWidth * 0.82;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();

          track.scrollBy({
            left: -distance,
            behavior: 'smooth'
          });
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();

          track.scrollBy({
            left: distance,
            behavior: 'smooth'
          });
        }
      });
    };

    const initialiseAllTracks = (container = document) => {
      container.querySelectorAll(trackSelector).forEach(initialiseTrack);

      if (container.matches?.(trackSelector)) {
        initialiseTrack(container);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initialiseAllTracks();
      });
    } else {
      initialiseAllTracks();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAllTracks(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nf-video-section]').forEach(function (section) {
  var current = 0;
  var playing = false;
  var timer = null;

  var tabs = Array.from(section.querySelectorAll('[data-nf-scene-tab]'));
  var backgrounds = Array.from(section.querySelectorAll('[data-nf-video-bg]'));
  var videos = Array.from(section.querySelectorAll('[data-nf-video]'));
  var total = tabs.length;
  var duration = parseInt(section.dataset.sceneDuration || '6', 10) * 1000;
  var play = section.querySelector('[data-nf-play-wrap]');
  var hudName = section.querySelector('[data-nf-hud-name]');
  var hudCounter = section.querySelector('[data-nf-hud-counter]');

  function getByScene(collection, index) {
    return collection.find(function (item) {
      return parseInt(item.dataset.sceneIndex, 10) === index;
    });
  }

  function playVideo(index) {
    var video = getByScene(videos, index);
    if (!video) return;

    video.muted = true;
    video.setAttribute('muted', '');

    var promise = video.play();
    if (promise !== undefined) {
      promise.catch(function () {});
    }
  }

  function pauseVideo(index) {
    var video = getByScene(videos, index);
    if (video && video.pause) video.pause();
  }

  function switchScene(index) {
    for (var i = 0; i < total; i++) {
      var background = getByScene(backgrounds, i);
      if (background) background.style.opacity = i === index ? '1' : '0';

      var tab = getByScene(tabs, i);
      if (tab) tab.classList.toggle('is-active', i === index);

      if (i === index && playing) {
        playVideo(i);
      } else {
        pauseVideo(i);
      }
    }

    var activeTab = getByScene(tabs, index);
    if (activeTab && hudName) {
      var title = activeTab.querySelector('.nf-tab-title');
      if (title) hudName.textContent = title.textContent;
    }

    if (hudCounter) {
      hudCounter.textContent =
        String(index + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    }

    current = index;

    if (playing) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        switchScene((current + 1) % total);
      }, duration);
    }
  }

  if (play) {
    play.addEventListener('click', function () {
      playing = true;
      play.classList.add('is-playing');

      playVideo(current);

      clearTimeout(timer);
      timer = setTimeout(function () {
        switchScene((current + 1) % total);
      }, duration);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      switchScene(parseInt(tab.dataset.index, 10));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-product-tech-specs-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-nf-tech-tab]');
  if (!tab) return;
  const root = tab.closest('[data-nf-tech-v2]');
  if (!root) return;
  const key = tab.dataset.nfTechTab;
  root.querySelectorAll('[data-nf-tech-tab]').forEach((button) => {
    const active = button === tab;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-selected', active ? 'true' : 'false');
    button.tabIndex = active ? 0 : -1;
  });
  root.querySelectorAll('[data-nf-tech-panel]').forEach((panel) => {
    const active = panel.dataset.nfTechPanel === key;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
});

document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('[data-nf-tech-tab]');
  if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  const root = tab.closest('[data-nf-tech-v2]');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[data-nf-tech-tab]')];
  const index = tabs.indexOf(tab);
  const nextIndex = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
  tabs[nextIndex].focus();
  tabs[nextIndex].click();
});

  } catch(e) { console.error(e); }
})();
})();
